// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"230":"c550a4c656a5835a0732","256":"a333c87b8fe8d3b1a45f","731":"7d2a7d5c5e1f40f87928","843":"4d704348052416620427"}[chunkId] + ".js";
};